import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ReCAPTCHA from "react-google-recaptcha";
//import ReactGA from "react-ga4";
// Material Kit 2 React components
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
// Images
import { Card, CardContent, Button, TextField } from "@mui/material";
import MKBox from "components/MKBox";
//import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import Slider from "rc-slider";
//import "rc-slider/assets/index.css";
import {
  CREATE_STRATEGYFOCUSAREAS,
  FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Focusareas = ({ selectedKunta, setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  const [fareas, setFareas] = useState([]);
  const [t] = useTranslation("common");
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted] = useState(false);
  const [executing] = useState(false);
  //console.log(setFareas);
  function valuetext(value) {
    return `${value}°C`;
  }
  //console.log(selectedKunta);
  const [limits, setLimits] = useState([25, 50, 75, 90]);
  const [limitslider, setLimitslider] = useState([25, 50, 75]);
  const [votes, setVotes] = useState([]);
  const [classes, setClasses] = useState([
    t("focusareas.children"),
    t("focusareas.seniors"),
    t("focusareas.sports"),
    t("focusareas.culture"),
  ]);
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    //console.log(token);
    setVerified(!verified);
  }
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = "anonym";
    if (localStorage.getItem("id") !== undefined) {
      // eslint-disable-next-line
      id = localStorage.getItem("id");
    }
    //console.log(id);
    /*ReactGA.event({
      category: "Focusareas",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    });
    */ // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/
  }, []);
  const [classs, setClasss] = useState("");
  //["Lapset ja nuoret", "Seniorit", "Liikunta ja vapaa-aika", "Kulttuuri"],
  const [createStrategyfocusareas] = useMutation(CREATE_STRATEGYFOCUSAREAS, {
    refetchQueries: [
      {
        query: FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY,
        variables: { municipality: selectedKunta },
      },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const sfareassw = useQuery(FIND_STRATEGYFOCUSAREAS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });

  useEffect(() => {
    let sfareass = [];
    //console.log(sfareassw);
    //let municipalitiess = [];
    if (sfareassw.data) {
      sfareass = sfareassw.data.findStrategyfocusareasByMunicipality;
      //setOrgans(organss);
      //console.log(sfareass);
      //let secs = sfareass.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsfareas(secs);
      setFareas(sfareass);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sfareassw]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    //console.log(limits);
    //console.log(classes);
    createStrategyfocusareas({
      variables: {
        weights: limits,
        weightclass: classes,
        strategydatetime: pvm.toString(),
        municipality: selectedKunta,
        userid: localStorage.getItem("id"),
        active: true,
      },
    });
  };

  function handleLimits(value) {
    //console.log(value);
    let lm = [];
    let s = 0;
    let su = 0;
    for (let i = 0; i < value.length; i++) {
      if (i < value.length - 1) {
        lm.push(value[i] - s);
        //console.log(lm);
        su = su + value[i] - s;
        s = value[i];
      } else {
        lm.push(value[i] - s);
        su = su + value[i] - s;
        lm.push(100 - su);
        //console.log(lm);
      }
    }
    setLimits(lm);
    setLimitslider(value);
    //console.log(limits);
    //console.log(limitslider);
  }
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategyfocusareaid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  useEffect(() => {
    let limit = 100 / classes.length;
    let lim = [];
    let limsli = [];
    let su = limit;
    for (let i = 0; i < classes.length; i++) {
      lim.push(limit);
      if (i !== classes.length - 1) {
        limsli.push(su);
      }
      su = su + limit;
    }
    setLimits(lim);
    setLimitslider(limsli);
  }, [classes]);
  function addRow(p) {
    //console.log(p);
    let txt = "";
    for (let i = 0; i < p.length; i++) {
      if (i === 0) {
        txt = p[i];
      } else {
        txt = txt + ", " + p[i];
      }
    }
    return txt;
  }
  function addWeights(p) {
    //console.log(p);
    let txt = "";
    for (let i = 0; i < p.length; i++) {
      if (i === 0) {
        txt = p[i] + " %";
      } else {
        txt = txt + ", " + p[i] + " %";
      }
    }
    return txt;
  }
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategyfocusareaid === p).length;
  }
  const handleRemoveclass = (event) => {
    //console.log(event);
    let newst = classes.filter((cont) => {
      return cont !== event;
    });
    //console.log(newst);
    setClasses(newst);
  };
  function addClass() {
    ////console.log(value);
    setClasses((classess) => [...classess, classs]);
    //console.log(classes);
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKBox component="section" py={6} my={6}>
            <Container>
              <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
                <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
                  <Grid container spacing={3}>
                    <h3>{t("focusareas.header")}</h3>
                    {t("focusareas.text")}
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </MKBox>
          <TextField
            label={t("focusareas.addcategory")}
            value={classs}
            onChange={(e) => setClasss(e.target.value)}
            variant="outlined"
            style={{ marginBottom: "0.5rem" }}
          />
          <Button variant="contained" style={{ color: "white" }} onClick={addClass}>
            {t("focusareas.addcategory")}
          </Button>
          <table style={{ width: "100%", textAlign: "center" }}>
            {classes.map((item, index) => (
              <tr key={item}>
                <td>{item}</td>
                <td>{limits[index]}</td>
                <td> %</td>
                <td>
                  <Button
                    variant="contained"
                    style={{ color: "white" }}
                    onClick={() => handleRemoveclass(item)}
                  >
                    {t("focusareas.delete")}
                  </Button>
                </td>
              </tr>
            ))}
          </table>
          <br />
          <br />
          <Slider
            color="primary "
            track={false}
            aria-labelledby="track-false-range-slider"
            getAriaValueText={valuetext}
            value={limitslider}
            marks
            onChange={(e) => handleLimits(e.target.value)}
            aria-label="Disabled slider"
            valueLabelDisplay="true"
          />
          <br />
          <br />
          <div style={{ width: "100%", marginLeft: "30%" }}>
            <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
          </div>
          <br />
          <Button
            variant="contained"
            style={{ color: "white" }}
            onClick={handleSubmit}
            disabled={!verified}
            executing={executing}
            submitted={submitted}
          >
            {t("focusareas.save")}
          </Button>
        </CardContent>
      </Card>
      <MKTypography variant="h4" gutterBottom>
        {t("focusareas.header")}
      </MKTypography>
      {fareas.length === 0 && <MKTypography>{t("focusareas.nosaved")}</MKTypography>}
      {fareas.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {addRow(item.weightclass)}: {addWeights(item.weights)}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Focusareas;
/***
 * 
 * <Slider
            color="primary "
            track={false}
            aria-labelledby="track-false-range-slider"
            getAriaValueText={valuetext}
            value={limitslider}
            marks
            onChange={(e) => handleLimits(e.target.value)}
            aria-label="Disabled slider"
            valueLabelDisplay="true"
          />
 */
